module.exports = __webpack_public_path__ + "media/images/lb/209-accf98c35112faec747ae70c8494116a.svg";